import React, { Component } from "react";


import { Link } from 'react-router-dom';
import './../../css/frame.css';
import './../../css/project.css';
import './index.scss';

class Index extends Component {

    constructor(props) {
        super(props);

        this.state = {
        }
    }

    onChange(value) {
        console.log(value);
    };
    goPage() {
        window.history.back(-1)
    };
    render() {

        return (
            <div data-component="detail">
                <div className="sg-detail">
                    <div className="sg-login-top">
                        <div onClick={this.goPage} className="sd-start">
                            <img className='sg-top-img11' alt='#' src={require('../../img/business/upPage.png')} />
                            <span className="sg-top-font">返回</span>
                        </div>
                    </div>
                    <div className="sg-center-detail">
                    <div className="sg-detail-font">电子营业执照使用操作指南</div>
                    <div className="sg-detail-fonts">（未领取电子营业执照）</div>
                    <div className="sg-detail-text">注:首次领取手机版电子营业执照，必须由法定代表人通过手机等移动终端完成。法定代表人领取手机版电子营业执照后，可自行或授权证照管理人员保管、持有、使用电子营业执照。法定代表人或者证照管理人员可授权办事人持电子营业执照办理相关的政务、商务、公共服务等业务，授权事项请选择“电子政务-市场监管 统一身份认证”。证照管理员和办事人经过授权后可下载电子营业执照并使用。</div>
                    <div className="sg-detail-text">1、请使用微信或支付宝扫描登录二维码，打开电子营业执照小程序，或进入电子营业执照小程序使用“扫一扫”扫描登录二维码。</div>
                    <div className="sg-detail-text">2、点击“下载执照”，录入姓名、身份证号等信息进行实名认证，如果实名认证不通过，需要到当地的市场监督部门扫码下载电子营业执照。</div>
                    <div>
                    <img className='sg-center-img' alt='#' src={require('../../img/screenshot/1.jpg')} />
                    <img className='sg-center-img' alt='#' src={require('../../img/screenshot/2.png')} />
                    </div>
                    <div>
                    <img className='sg-center-img' alt='#' src={require('../../img/screenshot/3.png')} />
                    <img className='sg-center-img' alt='#' src={require('../../img/screenshot/4.jpg')} />
                    </div>
                    <div className="sg-detail-text">3、通过实名认证后，选择企业所在的登记地，显示该登记地的所有可下载和已下载的执照记录，在“可下载执照记录”中选择企业名称，下载该企业的电子营业执照。</div>
                    <div>
                    <img className='sg-center-img' alt='#' src={require('../../img/screenshot/5.png')} />
                    <img className='sg-center-img' alt='#' src={require('../../img/screenshot/6.jpg')} />
                    </div>
                    <div className="sg-detail-text">4、下载电子营业执照前，需要阅读并同意《执照下载声明》。如果在本APP上修改过密码，下载时需要输入修改后的密码。</div>
                    <div className="sg-detail-text">5、执照下载成功后，可以继续下载其他的执照，也可以修改本手机当前APP已经下载的所有执照的密码，或者返回主页进行其他的操作。</div>
                    <div>
                    <img className='sg-center-img' alt='#' src={require('../../img/screenshot/7.jpg')} />
                    <img className='sg-center-img' alt='#' src={require('../../img/screenshot/8.jpg')} />
                    </div>
                    <div className="sg-detail-text">6、返回电子营业执照主页，点击”扫一扫”扫描申报系统的登录二维码，选择电子营业执照进行验证，验证通过后，点击”确认登录，即可在电脑端登录该企业。</div>
                    <div>
                    <img className='sg-center-img' alt='#' src={require('../../img/screenshot/9.jpg')} />
                    <img className='sg-center-img' alt='#' src={require('../../img/screenshot/10.jpg')} />

                    </div>
                    <div>
                    <img className='sg-center-img' alt='#' src={require('../../img/screenshot/11.jpg')} />
                    <img className='sg-center-img' alt='#' src={require('../../img/screenshot/12.jpg')} />

                    </div>
                    <div className="sg-detail-text"><Link to="/home/info" className="sg-strong-font">点击此处了解更多电子营业执照使用信息</Link>。</div>
                    <div className="sg-detail-text">如需电话咨询，请进入电子营业执照小程序查看、拨打企业登记地技术支持电话。</div>             
                    </div>
                    {/* <div className="sg-detail-font">{str}</div>
                    <div className="sg-detail-font">一、电子营业执照生成范围</div>
                    <div className="sg-detail-font">北京市市场监管局、各区市场监管局为登记管辖的企业、农民专业合作组织、个体工商户、外国（地区）企业常驻代表机构和外国（地区）企业在中国境内从事生产经营活动等各类市场主体提供电子营业执照。</div>
                    <div className="sg-detail-font">未更换加载“统一社会信用代码”营业执照的各类市场主体不生成电子营业执照。</div>
                    <div className="sg-detail-font">二、如何获得电子营业执照</div>
                    <div className="sg-detail-font">各类市场主体中国籍法定代表人、负责人等营业执照记载的人员可通过以下途径下载电子营业执照：</div>
                    <div className="sg-detail-font">（一）电子营业执照APP</div>
                    <div className="sg-detail-imgs sd-start">
                        <div className="sg-imgs-li sd-columnCenter sd-itemsStart">
                            <div className="sg-detail-font">安卓版：</div>
                        </div>
                        <div className="sg-imgs-li sd-columnCenter sd-itemsStart">
                            <div className="sg-detail-font">IOS版：</div>
                            <img className='sg-center-img' alt='#' src={require('../../img/business/image002.png')} />
                        </div>
                    </div>
                    <div className="sg-detail-font">注：安卓版请使用浏览器扫描二维码下载</div>
                    <div className="sg-detail-font">（二）扫描微信或支付宝小程序二维码下载电子营业执照</div>
                    <div className="sg-detail-imgs sd-start">
                        <div className="sg-imgs-li sd-columnCenter sd-itemsStart">
                            <img className='sg-center-img' alt='#' src={require('../../img/business/image003.jpg')} />
                        </div>
                        <div className="sg-imgs-li sd-columnCenter sd-itemsStart">
                            <img className='sg-center-img' alt='#' src={require('../../img/business/image004.jpg')} />
                        </div>
                    </div>
                    <div className="sg-detail-font">法定代表人、负责人等营业执照记载的人员通过电子营业执照APP、微信或支付宝小程序无法成功下载电子营业执照的，本人应携带纸质营业执照原件，到登记机关窗口提交有效期内的身份证明原件，办理“人证查验”。“人证查验”通过后，登记机关工作人员为其发放电子营业执照。</div>
                    <div className="sg-detail-font">上述人员提交的身份证明原件应为：</div>
                    <div className="sg-detail-font">1、中国籍自然人应提交第二代《中华人民共和国居民身份证》原件；</div>
                    <div className="sg-detail-font">2、港澳台人员应提交以下证件原件之一：</div>
                    <div className="sg-detail-font">香港、澳门特别行政区自然人应提供当地永久性居民身份证或特别行政区护照或往来内地通行证;台湾地区自然人应提供当地永久性居民身份证或者内地公安部门颁发的台湾居民来往大陆通行证。</div>
                    <div className="sg-detail-font">3、外籍人员应提交护照原件。</div>
                    <div className="sg-detail-font">登记多个执行事务合伙人（或委派代表）的合伙企业，执行事务合伙人（或委派代表）应共同指定其中之一作为电子营业执照持有人，向登记机关申请领取电子营业执照，<span className="sg-strong-font">除提交身份证明原件外，还应提交《合伙企业领取电子营业执照人员指定确认书》</span><a className="sg-strong-font" rel='noopener noreferrer' href="https://banshi.scjgj.beijing.gov.cn/zzyz/usenotice/hhqrs.doc" target="_blank">（点击此处下载）</a></div>
                    <div className="sg-detail-font">上述人员应向登记机关提供本人使用的手机号码，禁止使用他人手机接收验证码、扫描二维码下载电子营业执照。电子营业执照下载后可授权他人使用电子营业执照。</div>
                    
                    <div className="sg-detail-font">特此公告。</div>
                    <div className="sg-detail-font sg-text-indent">北京市市场监管局</div>
                    <div className="sg-detail-font sg-text-indent">2019年5月6日</div> */}
                </div>
            </div>
        )
    }
}

export default Index
